import axios from "axios";
import { useMemo, useState } from "react";



interface api {
    loading: boolean;
    error: boolean;
    data: any;
}

const getData = async () => {
    try {
        const { data } = await axios.get(
          "https://nftsurfaceboard.up.railway.app/api/aggregations/topWallets?topLevel=NFT&subLevel=9b4d3907d615294c5d4fdc4edf1e9b1e&pagination=%7B%22pageSize%22:4000,%22nextPageToken%22:%22%22%7D&rankingType=nft-ownership-current"
        )
        return data;
    }
    catch (error) {
        return error;
    }
}

export function useTopOwners() {
    const [api, setAPIData] = useState<api>({
        loading: true,
        error: false,
        data: [] || undefined
    });



    useMemo(async () => {
        const data = await getData();
        setAPIData({
            loading: false,
            error: false,
            data: data
        })
    }, [])
    return api;
}
